module.exports = {"url":"https://api.juphy.com"}


//////////////////
// WEBPACK FOOTER
// ./src/libs/config.json
// module id = 3dUn
// module chunks = 3